// extracted by mini-css-extract-plugin
export var wrapper = "about-module--wrapper--QfbvK";
export var column = "about-module--column--bdW9z";